import DiaperSizeBoxes from './DiaperSizeBoxes';
import { SizeBoxesLi, SizeBoxesOutter } from './styled';
import { useState } from 'react';
import { maternitySkusList } from '../../Product/OfferCarousel/constant';
import LactomamaFlavourBoxes from './LactomamaFlavourBoxes';
import { lactoMamaKey } from '../../../Constants/GeneralItemsKeys';
import { replaceUnderscore } from '../../../Utils/helper';

export default function SizeBoxes(props) {
  const {
    varientData,
    clickProductColorHandler,
    varientTitle,
    selectedSize,
    selectedData,
    productDetail,
    showNewLandingPageUI,
    showNewDiaperVariantUx,
    setShowSizeChartPopup,
    showNewLactomamaVariantUx,
    setUpdateVariant,
    updateVariant,
    setUserSelectedVariant,
    setSelectedVariant,
    packsCount,
    generalItemsDataByFlavour,
    flavourTitles,
    setGeneralItems,
    setTabThemeColor ,
    setTabThemeSecondaryColor,
  } = props;

  const customReducerState = selectedData;
  const key = 'title';
  const sizesArray = ['M', 'L', 'XL', 'XXL'];

  let arrayUniqueByKey = [
    ...new Map(varientData?.map((item) => [item[key], item])).values(),
  ];

  if (maternitySkusList.includes(parseInt(productDetail?.id))) {
    arrayUniqueByKey = arrayUniqueByKey.sort((a, b) => {
      const indexA = sizesArray.indexOf(a.title);
      const indexB = sizesArray.indexOf(b.title);
      if (indexA !== -1 && indexB !== -1) {
        return indexA - indexB;
      }
      if (indexA !== -1) return -1;
      if (indexB !== -1) return 1;
      return 0;
    });
  }

 

  const variantOptions = productDetail?.variantOption;
  const [focusElement, setFocusElement] = useState(null);
  const productClickHandler = (
    customReducerState = [],
    variantOptions = [],
    fallbackId = '',
    variantDetails,
  ) => {
    let shortListedItem = [];
    const combinedState = { ...customReducerState, ...variantDetails };
    let selectedElement = {};
    variantOptions.forEach((item, index) => {
      let outterIndex = index;
      item.data.forEach((data) => {
        if (
          data.title == combinedState[item?.variant_type?.toUpperCase()] &&
          data?.product_id === combinedState['productId'] &&
          outterIndex === 0
        ) {
          shortListedItem.push(data.web_url);
        } else if (
          data.title != combinedState[item?.variant_type?.toUpperCase()] &&
          outterIndex != 0
        ) {
          let indexValue = shortListedItem.indexOf(data.web_url);
          if (indexValue > -1) {
            shortListedItem.splice(indexValue, 1);
          }
        }
        const indexOfResult = item.data.findIndex(
          (i) => i.web_url == shortListedItem.toString(),
        );
        selectedElement = item.data[indexOfResult];
      });
    });
    clickProductColorHandler(
      shortListedItem.length > 0
        ? shortListedItem.toString()
        : fallbackId?.web_url
          ? fallbackId?.web_url
          : fallbackId?.product_id?.toString(),
      shortListedItem.length > 0 ? selectedElement : fallbackId,
      varientTitle,
      combinedState[varientTitle.toUpperCase()],
    );
    if (setShowSizeChartPopup) {
      setShowSizeChartPopup(false);
    }
  };
  const sizeClickHandler = (element, index) => {
    
    setFocusElement(index);
    setTimeout(() => {
      const variantDetails = {};
      variantDetails['productId'] = element?.product_id;
      variantDetails[varientTitle.toUpperCase()] = element?.title;
      let commonSizeIds = [];
      varientData.forEach((item) => {
        if (item?.title === element?.title) {
          commonSizeIds.push(item?.product_id);
        }
      });
      const selectedDataString = localStorage.getItem('selectedVariant');
      const currentVariant = JSON.parse(selectedDataString);
      for (const variant of variantOptions) {
        if (variant.variant_type != varientTitle) {
          for (const data of variant.data) {
            if (
              data.title != currentVariant['COLOR'] &&
              commonSizeIds.includes(data.product_id)
            ) {
              commonSizeIds = commonSizeIds.filter(
                (ele) => ele != data.product_id,
              );
            }
          }
        }
      }
      if (commonSizeIds?.length) {
        const productId = commonSizeIds[0];
        const variantDetail = varientData.find(
          (ele) => ele.product_id == productId,
        );
        if (variantDetail) {
          element = variantDetail;
        }
      }
      let ReducerState = customReducerState;
      if (productDetail?.isFashionFirst) {
        const selectedDataString = localStorage.getItem('selectedVariant');
        const data = JSON.parse(selectedDataString);
        if (data.hasOwnProperty('SIZE') && data?.SIZE == '') {
          data.SIZE = element?.title;
          localStorage.setItem('selectedVariant', JSON.stringify(data));
        }
        ReducerState['SIZE'] = element?.title;
      } else if (showNewLactomamaVariantUx) {
        const selectedDataString = localStorage.getItem('selectedVariant');
        const data = JSON.parse(selectedDataString);
        const selectedProductId = element?.product_id;
        let selectedPack = data.PACK;
        productDetail?.variantOption?.forEach((item) => {
          if (item?.variant_type == 'Pack') {
            const obj = item?.data?.find(
              (ele) => ele.product_id == selectedProductId,
            );
            selectedPack = obj?.title;
          }
        });
        data.PACK = selectedPack;
        data.productId = selectedProductId;
        if (data.hasOwnProperty('FLAVOUR')) {
          data.FLAVOUR = element?.title;
          localStorage.setItem('selectedVariant', JSON.stringify(data));
          setUpdateVariant(!updateVariant);
        }

        ReducerState['FLAVOUR'] = element?.title;
        const selectedFlavourTitle = element?.title;
         const categoryKey =
              selectedFlavourTitle === 'Elaichi'
                ? replaceUnderscore(lactoMamaKey)
                : `${replaceUnderscore(lactoMamaKey)}_${selectedFlavourTitle}`;
        
        if (
          selectedFlavourTitle &&
          generalItemsDataByFlavour[selectedFlavourTitle]
        ) {
          // Get the data for the selected flavour
          const selectedFlavourData =
            generalItemsDataByFlavour[selectedFlavourTitle];
         

          // Set the general items with the selected flavour's data
          setGeneralItems?.(selectedFlavourData);
          setTabThemeColor?.(selectedFlavourData.tabThemeColor)
          setTabThemeSecondaryColor?.(selectedFlavourData.tabThemeSecondaryColor)
        } else {
         
        }
        setUserSelectedVariant(element.product_id);
        setSelectedVariant(element.product_id);
      } else {
        ReducerState = ReducerState;
      }
      if (!showNewLactomamaVariantUx) {
        productClickHandler(
          ReducerState,
          variantOptions,
          element,
          variantDetails,
        );
      }
      setFocusElement(null);
    }, 100);
  };

  let bestVal = 0;
  let ppu = 1000000000;
  if (
    varientTitle?.toLowerCase() !== 'size' &&
    varientTitle?.toLowerCase() !== 'flavour'
  ) {
    arrayUniqueByKey?.map((element, index) => {
      if (element?.title != 'Mini Pack') {
        const { price, quantityPerPack, packPerProduct } = element;
        const elemntPpu = price / (quantityPerPack * packPerProduct);
        if (elemntPpu < ppu) {
          ppu = elemntPpu;
          bestVal = index;
        }
        element.ppu = elemntPpu;
      }
    });
    const element = arrayUniqueByKey.splice(bestVal, 1)[0];
    arrayUniqueByKey.unshift(element);
    arrayUniqueByKey.sort((a, b) => a.ppu - b.ppu);
  }

  return (
    <SizeBoxesOutter
      className={showNewLandingPageUI ? 'newUI' : ''}
      id="sizeBoxOutter"
      showNewDiaperVariantUx={
        showNewDiaperVariantUx || showNewLactomamaVariantUx
      }
      botPadding={
        varientTitle?.toLowerCase() == 'size' ||
        varientTitle?.toLowerCase() == 'flavour'
      }
    >
      {arrayUniqueByKey?.map((element, index) => {
        if (selectedSize == element?.title) {
          const scrollDifference =
            window?.screen?.width -
            document
              ?.getElementById(`${element?.name + index}`)
              ?.getBoundingClientRect().x;
          if (scrollDifference < 25)
            document.getElementById(`sizeBoxOutter`).scrollLeft =
              scrollDifference + 64;
        }

        if (element?.title != 'Mini Pack' && element?.title != 'Travel Pack')
          return showNewDiaperVariantUx ? (
            <DiaperSizeBoxes
              sizeClickHandler={sizeClickHandler}
              varientTitle={varientTitle}
              showNewDiaperVariantUx={showNewDiaperVariantUx}
              element={element}
              index={index}
              key={index}
              focusElement={focusElement}
              selectedSize={selectedSize}
              packsCount={packsCount}
            />
          ) : showNewLactomamaVariantUx ? (
            <LactomamaFlavourBoxes
              sizeClickHandler={sizeClickHandler}
              varientTitle={varientTitle}
              element={element}
              index={index}
              key={index}
              focusElement={focusElement}
              selectedSize={selectedSize}
              generalItemsDataByFlavour={generalItemsDataByFlavour}
              flavourTitles={flavourTitles}
              setGeneralItems={setGeneralItems}
              setTabThemeColor={setTabThemeColor}
            />
          ) : (
            <SizeBoxesLi
              id={`${element?.name + index}`}
              key={index}
              style={{ opacity: focusElement == index ? 0.4 : 1 }}
              onClick={() => sizeClickHandler(element, index)}
              active={selectedSize == element?.title}
            >
              <p className="size_title">{element?.title}</p>
            </SizeBoxesLi>
          );
      })}
    </SizeBoxesOutter>
  );
}
